export default __webpack_public_path__ + "static/media/place-order.e39a1c12.mp4";